/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-22 14:09:06
 * @LastEditors: K
 * @LastEditTime: 2022-09-07 16:56:29
 */

export const getBackgroundColor = (i: number): string => {
  switch (i) {
    case 1:
      return '#027AFF'
    case 2:
      return '#FBB234'
    case 3:
      return '#76DB63'
    case 4:
      return '#655FD1'
    case 5:
      return '#f5823f'
    default:
      return '#027AFF'
  }
}

export const getOrganizationPlaneName = (key: string): string => {
  switch (key) {
    case 'tenantNum':
      return '机构总数'
    case 'activeTenantNum':
      return '活跃机构数'
    case 'insuranceTenantNum':
      return '医保机构数'
    case 'newPayTenantNum':
      return '付费机构数'
    case 'newLoseTenantNum':
      return '流失机构数'
    case 'doctorNum':
      return '医生总数'
    case 'activeDoctorNum':
      return '活跃医生数'
    case 'patientNum':
      return '患者总数'
    case 'seeingNum':
      return '就诊次数'
    case 'settlementNum':
      return '结算笔数'
    case 'settlementMoney':
      return '结算金额'
    case 'recipeNum':
      return '处方总数'
    case 'medicalRecordNum':
      return '病历总数'
    case 'universalMedicalRecordNum':
      return '通用病历'
    case 'tcmMedicalRecordNum':
      return '中医病历'
    case 'mouthMedicalRecordNum':
      return '口腔病历'
    case 'beautyClinicMedicalRecordNum':
      return '医美病历'
    case 'patientSexVO':
      return '患者性别分布'
    case 'patientAgeVO':
      return '患者年龄分布'
    case 'medicalPieChartVOS':
      return '病历分布'
    case 'recipePieChartVO':
      return '处方分布'
    case 'settlementAmountPieChartVO':
      return '结算金额分布'
    case 'liabilityVOList':
      return '排列前五的高发疾病'
    case 'f':
      return '各省机构总览'
    case 'g':
      return '各省机构分布图'
    case 'organization':
      return '近一年机构趋势图'
    case 'i':
      return '机构活跃明细'
    case 'orderNum':
      return '总笔数'
    case 'productMoney':
      return '总金额'
    case 'addedServices':
      return '近一年开通增值服务机构趋势图'
    case 'addedServicesOperating':
      return '近一年增值服务运营趋势图'
    case 'productCenter':
      return '近一年产品中心趋势图'
    case 'doctorTrend':
      return '近一年医生趋势图'
    case 'visitTrendChart':
      return '近一年就诊趋势图'
    case 'q':
      return '各机构医生分布'
    case 'r':
      return '医生性别分布'
    case 's':
      return '医生年龄分布'
    case 'medicalRecords':
      return '近一年病历趋势图'
    case 'settlement':
      return '近一年就诊结算趋势图'
    default:
      return '未知数据'
  }
}


export enum pieNum {
  XYF = 0, 
  ZHF = 1, 
  KLCYF = 2, 
  ZL = 3, 
  JC = 4, 
  CZXM = 5, 
  QT = 6, 
  LSKD = 7, 
  GH = 8, 
}
export const pieNums = [
  pieNum.XYF, 
  pieNum.ZHF, 
  pieNum.KLCYF, 
  pieNum.ZL,
  pieNum.JC,
  pieNum.CZXM,
  pieNum.QT,
  pieNum.LSKD,
  pieNum.GH,
]

export function pieNumName(pieNum: pieNum): string {
  switch (pieNum) {
    case 0:
      return '西药方'
    case 1:
      return '中药方'
    case 2:
      return '颗粒草药方'
    case 3:
      return '治疗'
    case 4:
      return '检查'
    case 5:
      return '处置项目'
    case 6:
      return '其他'
    case 7:
      return '零售开单'
    case 8:
      return '挂号'
    default:
      return ''
  }
}
